import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import axios from "axios";
import {
  validaSoloNumero,
  validaNumeroTelefono,
  validaEmail,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
} from "../../util/varios";
import moment from "moment";
import { Mensaje, MensajeSiNo } from "../mensajes";

export const RecuperarInformacion = (props) => {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const txtContraseña = useRef();
  const txtContraseñaNueva = useRef();
  const txtConfirmar = useRef();
  const [message, setMessage] = useState("hidden");
  const [teclas, setTeclas] = useState();
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [tipoActual, setTipoActual] = useState("password");
  const [tipoNuevo, setTipoNuevo] = useState("password");
  const [deshabilitado, setDesabilitado] = useState(true);
  const [deshabilitarBtn, setDesabilitarBtn] = useState(true);

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const generar = (longitud) => {
    var long = parseInt(longitud);
    var caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ012346789";
    var contraseña = "";
    for (var i = 0; i < long; i++)
      contraseña += caracteres.charAt(
        Math.floor(Math.random() * caracteres.length)
      );
    return contraseña;
  };

  const handleCloseSi = () => {
    SelectUsuario(txtContraseña.current.value);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const blanquear = () => {
    txtContraseña.current.value = "";

    setDesabilitado(true);
    setDesabilitarBtn(true);
    setTipoActual("password");
    setTipoNuevo("password");
  };

  const enviarCorreo = (data, pass) => {
    let endpoint = op.email + "/send-email";

    axios
      .post(endpoint, {
        email: data.correoe,
        name: data.login,
        passwd: pass,
        message: "Estos son Actualmente sus datos.",
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto:
              "Contraseña Cambiada Correctamente! " +
              response.data.respuesta +
              data.login,
            icono: "exito",
          });
        } else if (response.status == 204) {
          setMensaje({
            mostrar: true,
            titulo: "Confirmación.",
            texto: response.respuesta,
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const procesarRegistro = (data) => {
    let endpoint = `${op.conexion}/api/comun/cambioclave/usuariotimbre`;
    setActivate(true);
    let pass = generar(6).toString();
    let body = {
      passwd: pass,
      login: data.login.trim(),
      idusuario: parseInt(data.idusuario),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          enviarCorreo(data, pass);
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Cambiar Contraseña",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SelectUsuario = (correo) => {
    let endpoint = `${op.conexion}/api/comun/usuarioxpersona?correo=${correo}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setActivate(false);
          if (response.data !== "") {
            console.log(response.data);
            procesarRegistro(response.data);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "No existe Usuario Registrado con este Correo.",
              icono: "informacion",
            });
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarPropie = (event) => {
    event.preventDefault();

    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: "Desea Recuperar la información",
      icono: "confirmacion",
    });
  };

  const verClave = (tipo) => (e) => {
    e.preventDefault();
    if (tipo === 1) {
      if (tipoActual === "password") {
        setTipoActual("text");
      } else {
        setTipoActual("password");
      }
    } else if (tipo === 2) {
      if (tipoNuevo === "password") {
        setTipoNuevo("text");
      } else {
        setTipoNuevo("password");
      }
    }
  };
  const cerrarModal = () => {
    props.onHideCancelar();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  useEffect(() => {}, []);
  //console.log(values)

  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {}}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Recuperar Información</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} />
        <div className="container-fluid  rounded row mx-auto">
          <div class="mb-1">
            <label for="exampleInputEmail1" class="form-label">
              Correo Electronico:
            </label>
            <div class="input-group input-group-sm ">
              <input
                type="text"
                class="form-control"
                aria-label="Sizing example input"
                name="passw"
                ref={txtContraseña}
                onChange={(event) => {
                  event.target.value !== ""
                    ? setDesabilitarBtn(false)
                    : setDesabilitarBtn(true);
                }}
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          style={{ margin: "1px" }}
          onClick={validarPropie}
          disabled={deshabilitarBtn}
          className=" btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i>Aceptar
        </button>
        <button
          type="button"
          onClick={cancelar}
          style={{ margin: "1px" }}
          className=" btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i>Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/recuperacionInfo/recuperarInfo.js